import * as Sentry from '@sentry/react';

import { ReactNode } from 'react';

import { ErrorFallback } from './components/ErrorFallback';

interface Props {
  children: ReactNode;
  boundaryTag: string;
}

export default function ErrorBoundary(props: Props) {
  const dialogsEnabled =
    import.meta.env.VITE_NODE_ENV !== 'production' &&
    import.meta.env.VITE_ENABLE_SENTRY_DIALOGS == 'true'; //eslint-disable-line eqeqeq
  const dialogOptions = {
    title: 'Ein Problem trat auf',
    subtitle: 'Unser Team arbeitet daran'
  };

  return (
    <Sentry.ErrorBoundary
      showDialog={dialogsEnabled}
      dialogOptions={dialogOptions}
      fallback={({ error, resetError, componentStack }) => {
        return (
          <ErrorFallback error={error} resetError={resetError} componentStack={componentStack} />
        );
      }}
      beforeCapture={scope => {
        scope.setTag('boundaryTag', props.boundaryTag);
      }}
    >
      {props.children}
    </Sentry.ErrorBoundary>
  );
}
